//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular, { IHttpService, IPromise } from 'angular';

import {
  IExperiencePreviewRequest,
  IExperiencePreviewResponse,
  IExperiencesResponse
} from '@apis/experiences/experiencesApiModels';
import ExperienceContainerId from '@models/ExperienceContainerId';

export default class ExperiencesApiService {
  private webGatewayUrl = this.sessionVarsService.getBaseUrl('experience_gateway');
  private urlRequestBase = `${this.webGatewayUrl}${this.RestBaseUrl}/v1`;

  constructor(
    private $http: IHttpService,
    private promiseService,
    private RestBaseUrl,
    private sessionVarsService,
  ) { }

  public updateExperienceAsync(containerId: ExperienceContainerId, options): IPromise<any> {
    return this.promiseService.processHttpResponse(this.$http.put(
      `${this.urlRequestBase}/experiences/${containerId}`,
      options,
    ));
  }

  public getExperiencesAsync(): IPromise<IExperiencesResponse> {
    return this.promiseService.processHttpResponse(this.$http.get(`${this.urlRequestBase}/experiences`));
  }

  public deleteExperienceAsync(containerId: ExperienceContainerId): IPromise<any> {
    return this.promiseService.processHttpResponse(this.$http.delete(
      `${this.urlRequestBase}/experiences/${containerId}`,
    ));
  }

  public getExperiencePreview(
    containerId: ExperienceContainerId,
    options: IExperiencePreviewRequest
  ): IPromise<IExperiencePreviewResponse> {
    return this.promiseService.processHttpResponse(this.$http.post(
      `${this.urlRequestBase}/experiences/${containerId}/preview`,
      options,
    ));
  }
}

angular.module('curalate').service('ExperiencesApiService', [
  '$http',
  'PromiseService',
  'RestBaseUrl',
  'SessionVarsService',
  ExperiencesApiService,
]);
